var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOutlinedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16699 16.0001C3.16699 8.63945 9.13969 2.66675 16.5003 2.66675C23.861 2.66675 29.8337 8.63945 29.8337 16.0001C29.8337 23.3607 23.861 29.3334 16.5003 29.3334C9.13969 29.3334 3.16699 23.3607 3.16699 16.0001ZM5.38921 16.0001C5.38921 9.86675 10.367 4.88897 16.5003 4.88897C22.6337 4.88897 27.6114 9.86675 27.6114 16.0001C27.6114 22.1334 22.6337 27.1112 16.5003 27.1112C10.367 27.1112 5.38921 22.1334 5.38921 16.0001ZM15.3892 19.3334V21.5556H17.6114V19.3334H15.3892ZM15.3892 17.1112H17.6114V10.4445H15.3892V17.1112Z",
    fill: "#89A6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutlinedBlue);
export default __webpack_public_path__ + "static/media/info-outlined-blue.d083b8f55aa3fd0c496d11403142a4b8.svg";
export { ForwardRef as ReactComponent };